<template>
  <div>
    <!-- 顶部面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单查询 -->
    <div class="bg-white pd-5">
      <el-form :inline="true" ref="form" :model="form" label-width="80px">
        <el-form-item label="订单编号">
          <el-input
            v-model="form.orderNo"
            placeholder="请输入订单编号"
            clearable
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="客户编号">
          <el-input
            v-model="form.userNum"
            placeholder="请输入客户编号"
            clearable
          ></el-input>
        </el-form-item> -->
        <el-form-item label="是否退款">
          <el-select v-model="form.isRefund" clearable placeholder="全部">
            <el-option label="未退款" value="1"></el-option>
            <el-option label="退款中" value="2"></el-option>
            <el-option label="已退款" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充值方式">
          <el-select
            multiple
            v-model="form.orderType"
            clearable
            placeholder="全部"
          >
            <el-option label="用户套餐充值" value="1"></el-option>
            <el-option label="活动套餐充值" value="2"></el-option>
            <el-option label="小程序活动套餐" value="19"></el-option>
            <el-option label="活动充值" value="3"></el-option>
            <el-option label="接卡" value="4"></el-option>
            <el-option label="套餐过期(扣减余额)" value="5"></el-option>
            <el-option label="水卡清零(扣减余额)" value="6"></el-option>
            <el-option label="区域迁移充值" value="7"></el-option>
            <el-option label="订单补偿" value="8"></el-option>
            <el-option label="合伙人提现" value="9"></el-option>
            <el-option label="合伙人套餐充值" value="20"></el-option>
<!--            <el-option label="首次充值奖励" value="10"></el-option>-->
            <!--            <el-option label="新用户绑卡奖励" value="11"></el-option>-->
            <!-- <el-option label="服务迁移充值" value="12"></el-option> -->
            <el-option label="余额转移(增加余额)" value="13"></el-option>
            <el-option label="余额转移(扣减余额)" value="14"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属分区">
          <el-select
            multiple
            filterable
            v-model="form.fenqu"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="(v, i) in zoneArr"
              :key="i"
              :label="v.regionName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="水卡类型">
          <el-select v-model="form.cardType" clearable placeholder="全部">
            <el-option label="电子卡" value="1"></el-option>
            <el-option label="实物卡" value="2"></el-option>
            <!-- <el-option label="时效电子卡" value="3"></el-option>
            <el-option label="时效实物卡" value="4"></el-option> -->
          </el-select>
        </el-form-item>
      </el-form>
      <el-form :inline="true" ref="form" :model="form" label-width="80px">
        <el-form-item label="水卡编号">
          <el-input
            v-model="form.waterCard"
            placeholder="请输入水卡编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="是否空分">
          <el-select v-model="form.isKf" placeholder="全部" clearable>
            <el-option label="是" value="true"></el-option>
            <el-option label="否" value="false"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="操作">
          <el-input
            v-model="form.caozuo"
            placeholder="请输入水卡编号"
            clearable
          ></el-input>
        </el-form-item> -->
        <el-form-item label="操作人">
          <el-select
            multiple
            filterable
            v-model="form.caozuo"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="(v, i) in caozuorenArr"
              :key="i"
              :label="v.name"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充值时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="$forceUpdate()"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="$forceUpdate()"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="
              getList();
              getStat();
            "
            >查询</el-button
          >
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 统计 -->
    <div class="flex f14 fw-600 mgt-20 mgb-10  color052173">
      <span class="mgr-20">充值订单数（笔）：{{ rechargeNum }}</span>
      <span class="mgr-20">合计到卡金额（元）：{{ rechargeReal }}</span>
      <span class="mgr-20">实付金额（元）：{{ allPay }}</span>
      <span class="mgr-20">赠送金额（元）：{{ allSend }}</span>
      <div class="moreBtn" @click="totalVisible = true">更多></div>
    </div>
    <!-- 温馨提示 -->
    <!-- <div class="mgt-10 mgb-20 color052154">
      温馨提示：实物水卡后台充值金额不支持提现，客户需线下充值请现场收取应付金额。
    </div> -->
    <btns class="mgb-15" @exec="exec"></btns>

    <!-- 表格 -->
    <el-table :data="tableData" border stripe style="width: 100%">
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="80"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="orderNo" label="订单编号"> </el-table-column>
      <el-table-column prop="waterCard" label="水卡编号"> </el-table-column>
      <el-table-column prop="address" label="水卡类型">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.cardType == 1
                ? '电子卡'
                : scope.row.cardType == 2
                ? '实物卡'
                : scope.row.cardType == 3
                ? '时效电子卡'
                : scope.row.cardType == 4
                ? '时效实物卡'
                : ''
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="用户手机号"> </el-table-column>
      <el-table-column prop="address" label="订单来源">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.sceneId == -1
                ? '后台'
                : scope.row.sceneId == 2
                ? '校园'
                : scope.row.sceneId == 3
                ? '社区'
                : '- -'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="regionName" label="所属分区"> </el-table-column>

      <el-table-column prop="address" label="充值方式">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.orderType == 1
                ? '用户套餐充值'
                : scope.row.orderType == 2
                ? '活动套餐充值'
                : scope.row.orderType == 3
                ? '活动充值'
                : scope.row.orderType == 4
                ? '接卡'
                : scope.row.orderType == 5
                ? '套餐过期(扣减余额)'
                : scope.row.orderType == 6
                ? '水卡清零(扣减余额)'
                : scope.row.orderType == 7
                ? '区域迁移充值'
                : scope.row.orderType == 8
                ? '区域订单补偿'
                : scope.row.orderType == 9
                ? '合伙人提现'
                : scope.row.orderType == 10
                ? '首次充值奖励'
                : scope.row.orderType == 11
                ? '新用户绑卡奖励'
                : scope.row.orderType == 12
                ? '服务迁移充值'
                : scope.row.orderType == 13
                ? '余额转移(增加余额)'
                : scope.row.orderType == 14
                ? '余额转移(扣减余额)'
                : scope.row.orderType == 19
                ? '小程序活动套餐充值'
                : scope.row.orderType == 20
                ? '合伙人套餐充值'
                : '- -'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="payType" label="是否空分">
        <template slot-scope="scope">
          <span
            v-text="scope.row.isKf && scope.row.isKf == true ? '是' : '否'"
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="payPrice" label="实付金额（元）">
      </el-table-column>
      <el-table-column prop="givePrice" label="赠送金额（元）">
      </el-table-column>
      <el-table-column prop="orderPrice" label="到卡金额（元）">
      </el-table-column>
      <el-table-column prop="payName" label="是否退款 ">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.state == 6
                ? '已退款'
                : scope.row.state == 5
                ? '退款中'
                : '未退款'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="referencePhone" label="销售人员">
        <template slot-scope="scope">
          <span
            v-text="scope.row.referencePhone ? scope.row.referencePhone : '- -'"
          ></span>
        </template>
      </el-table-column>

      <el-table-column prop="payName" label="操作人"> </el-table-column>
      <el-table-column prop="payTime" label="交易时间"> </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>

    <!-- 订单统计弹框 -->

    <el-dialog
      title="订单统计"
      :visible.sync="totalVisible"
      width="40%"
      center
      :close-on-click-modal="false"
      top="30vh"
    >
      <div class="color052173 fw-600 mgb-5">充值订单</div>
      <el-descriptions column="4" border>
        <el-descriptions-item label="总数(笔)">{{
          rechargeNum
        }}</el-descriptions-item>
        <el-descriptions-item label="到卡金额(元)">{{
          rechargeReal
        }}</el-descriptions-item>
        <el-descriptions-item label="实付金额(元)">{{
          allPay
        }}</el-descriptions-item>
        <el-descriptions-item label="赠送金额(元)">{{
          allSend
        }}</el-descriptions-item>
      </el-descriptions>
      <div class="mgt-15" style="color: red">
        说明：充值订单未统计套餐过期和水卡清零的订单数据。
      </div>
      <div class="color052173 fw-600 mgb-5 mgt-5">失效订单</div>
      <el-descriptions column="4" border>
        <el-descriptions-item label="总数(笔)">{{
          outrechargeNum
        }}</el-descriptions-item>
        <el-descriptions-item label="失效金额(元)">{{
          outrechargeReal
        }}</el-descriptions-item>
        <el-descriptions-item label="实付金额(元)">{{
          outallPay
        }}</el-descriptions-item>
        <el-descriptions-item label="赠送金额(元)">{{
          outallSend
        }}</el-descriptions-item>
      </el-descriptions>
      <div class="mgt-15" style="color: red">
        说明：失效订单仅包含套餐过期和水卡清零的订单数据。
      </div>
      <div class="color052173 fw-600 mgb-5 mgt-5">区域迁移订单</div>
      <el-descriptions column="4" border>
        <el-descriptions-item label="总数(笔)">{{
          qianyirechargeNum
        }}</el-descriptions-item>
        <el-descriptions-item label="迁移金额(元)">{{
          qianyirechargeReal
        }}</el-descriptions-item>
        <el-descriptions-item label="实付金额(元)">{{
          qianyiallPay
        }}</el-descriptions-item>
        <el-descriptions-item label="赠送金额(元)">{{
          qianyiallSend
        }}</el-descriptions-item>
      </el-descriptions>
      <div class="mgt-15" style="color: red">
        说明：区域迁移订单为租赁企业区域转移时水卡余额迁移企业产生的记录，无实际支付或赠送，不进行收益统计和订单分润。
      </div>
      <div class="color052173 fw-600 mgb-5 mgt-5">余额转移(扣减余额)</div>
      <el-descriptions column="4" border>
        <el-descriptions-item label="总金额(元)">{{
          shiftMoney
        }}</el-descriptions-item>
        <el-descriptions-item label="赠送金额(元)">{{
          shiftGive
        }}</el-descriptions-item>
        <el-descriptions-item label="实付金额(元)">{{
          shiftReal
        }}</el-descriptions-item>
      </el-descriptions>
      <div class="mgt-15" style="color: red">
        说明：通过余额转移扣减的充值金额会从充值总金额中同步减去。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="totalVisible = false">已知晓</el-button>
      </span>
    </el-dialog>

    <!-- 导出弹框 -->
    <el-dialog
      title="导出"
      :visible.sync="exportVisible"
      width="30%"
      center
      :close-on-click-modal="false"
      top="30vh"
    >
      <div class="mgb-10">温馨提示:不填写条件则导出全部</div>
      <el-form
        :rules="exportFormRules"
        ref="exportForm"
        :model="exportForm"
        label-width="80px"
      >
        <!-- <el-form-item label="归属企业">
          <el-select
            multiple
            clearable
            filterable
            v-model="exportForm.qiye"
            placeholder="全部"
          >
            <el-option
              v-for="(v, i) in guishuqiye"
              :key="i"
              :label="v.companyName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="所属分区">
          <el-select
            multiple
            clearable
            filterable
            v-model="exportForm.fenqu"
            placeholder="全部"
          >
            <el-option
              v-for="(v, i) in zoneArr"
              :key="i"
              :label="v.regionName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="充值方式">
          <el-select
            clearable
            multiple
            v-model="exportForm.orderType"
            placeholder="全部"
          >
            <el-option label="用户套餐充值" value="1"></el-option>
            <el-option label="活动套餐充值" value="2"></el-option>
            <el-option label="活动充值" value="3"></el-option>
            <el-option label="小程序活动套餐充值" value="19"></el-option>
            <el-option label="接卡" value="4"></el-option>
            <el-option label="套餐过期(扣减余额)" value="5"></el-option>
            <el-option label="水卡清零(扣减余额)" value="6"></el-option>
            <el-option label="区域迁移充值" value="7"></el-option>
            <el-option label="订单补偿" value="8"></el-option>
            <el-option label="合伙人提现" value="9"></el-option>
            <el-option label="合伙人套餐充值" value="20"></el-option>
<!--            <el-option label="首次充值奖励" value="10"></el-option>-->
            <el-option label="新用户绑卡奖励" value="11"></el-option>
            <!-- <el-option label="服务迁移充值" value="12"></el-option> -->
            <el-option label="余额转移(增加余额)" value="13"></el-option>
            <el-option label="余额转移(扣减余额)" value="14"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="水卡类型">
          <el-select clearable v-model="exportForm.type" placeholder="全部">
            <el-option label="电子水卡" value="1"></el-option>
            <el-option label="实物水卡" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易时间">
          <div class="flex">
            <el-date-picker
              v-model="exportForm.startTime"
              format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="开始日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="exportForm.endTime"
              :picker-options="pickerOptionsEnd8"
              format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <!-- <el-form-item label="页码" prop="pageNum">
          <el-input
            v-model="exportForm.pageNum"
            placeholder="请输入页码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="每页条数" prop="pageSize">
          <el-input
            v-model="exportForm.pageSize"
            placeholder="请输入每页条数"
            clearable
          ></el-input>
        </el-form-item> -->
        <el-form-item label="是否空分">
          <el-radio-group v-model="exportKongFen">
            <el-radio :label="0">全部</el-radio>
            <el-radio :label="1">无空分订单</el-radio>
            <el-radio :label="2">仅含空分订单</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="exportVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="exportBtn('exportForm')"
          >导 出</el-button
        >
      </span>
    </el-dialog>

    <!-- 导出选择数据弹框 -->
    <el-dialog
      title="导出"
      :visible.sync="exportChangeNumVisible"
      width="60%"
      center
      :close-on-click-modal="false"
      top="30vh"
    >
      <el-descriptions column="5" border title="请选择需要导出的数据">
        <el-descriptions-item v-for="(v, i) in radioArr" :key="i" label="范围">
          <el-radio v-model="radio" :label="v.id" @input="changeRadioInput">{{
            v.start + "-" + v.end + "条"
          }}</el-radio></el-descriptions-item
        >
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="exportChangeNumVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="exportNumBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
import btns from "@/components/btns.vue";
import store from "../../store";

export default {
  components: {
    breadcrumbs,
    btns
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      },
      form: {},
      tableData: [],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 10, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      // rechargeReal: 0,
      // actual: 0,
      // undetermined: 0,
      // rechargeNum: 0,
      zoneArr: [],
      caozuorenArr: [],
      totalVisible: false,
      rechargeReal: 0,
      allSend: 0,
      allPay: 0,

      actual: 0,
      actualSend: 0,
      actualPay: 0,

      undetermined: 0,
      undeterminedSend: 0,
      undeterminedPay: 0,

      rechargeNum: 0,
      guishuqiye: [],
      outrechargeNum: 0,
      outrechargeReal: 0,
      outallPay: 0,
      outallSend: 0,
      qianyirechargeNum: 0,
      qianyirechargeReal: 0,
      qianyiallPay: 0,
      qianyiallSend: 0,
      shiftMoney: 0,
      shiftGive: 0,
      shiftReal: 0,
      exportVisible: false,
      exportForm: {
        orderType: "",
        startTime: "",
        endTime: "",
        type: ""
      },
      pickerOptionsEnd8: {
        disabledDate: time => {
          let beginDateVal = this.exportForm.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      },
      radio: "1",
      radioArr: [],
      exportChangeNumVisible: false,
      exportNum: null,
      interval: 2000,
      companyId: null,

      // 新增导出弹窗增加是否含空分选项
      exportKongFen: 0
    };
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
    "exportForm.startTime"() {
      if (this.exportForm.startTime == null) {
        this.exportForm.endTime = null;
      }
    }
  },
  created() {
    this.getROLE();
    this.getList();
    this.getStat();
    this.getZone();
    this.getUser();
  },
  methods: {
    getROLE() {
      var token = store.getters.get_token;
      if (token) {
        this.companyId = token.companyId;
      }
    },
    exportNumBtn() {
      if (!this.radio) {
        handleAlert("请选择条数范围", "error");
        return;
      }
      this.radioArr.forEach(v => {
        if (this.radio == v.id) {
          this.exportForm.limitStart = v.start;
          this.exportForm.limitEnd = v.end;
        }
      });

      let topExportData = {
        companyId: this.exportForm.qiye,
        orderType: this.exportForm.orderType,
        cardType: this.exportForm.type,
        startTime: this.exportForm.startTime,
        endTime: this.exportForm.endTime,
        pageNum: this.exportForm.pageNum,
        pageSize: this.exportForm.pageSize,
        // regionId: this.exportForm.fenqu,
        type: 1,
        limitEnd: this.exportForm.limitEnd,
        limitStart: this.exportForm.limitStart
      };
      if (this.exportKongFen == 1) {
        // eslint-disable-next-line no-const-assign
        topExportData.isKf = false;

        //
      }
      if (this.exportKongFen == 2) {
        // eslint-disable-next-line no-const-assign
        topExportData.isKf = true;
      }
      handleConfirm("确认导出吗?", "info")
        .then(() => {
          this.$api.order.topExport(topExportData).then(res => {
            handleAlert("导出成功", "success");
            this.exportChangeNumVisible = false;
            const link = document.createElement("a");
            link.style.display = "none";
            link.href = URL.createObjectURL(res);
            link.setAttribute("download", "充值订单.xls");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          });
        })
        .catch(() => {
          return;
        });
    },
    exportBtn(d) {
      // 导出是否空分
      let topExportNumData = {
        companyId: this.exportForm.qiye,
        orderType: this.exportForm.orderType,
        cardType: this.exportForm.type,
        startTime: this.exportForm.startTime,
        endTime: this.exportForm.endTime,
        pageNum: this.exportForm.pageNum,
        pageSize: this.exportForm.pageSize,
        // regionId: this.exportForm.fenqu,
        type: 0
      };
      let topExportData = {};
      if (this.exportKongFen == 1) {
        // eslint-disable-next-line no-const-assign
        topExportNumData.isKf = false;

        //
      }
      if (this.exportKongFen == 2) {
        // eslint-disable-next-line no-const-assign
        topExportNumData.isKf = true;
      }
      this.$refs[d].validate(valid => {
        if (valid) {
          this.$api.order.topExportNum(topExportNumData).then(a => {
            if (a.code === 200) {
              if (Number(a.data) > this.interval) {
                this.radioArr = []; // 清空之前的范围
                let id = 1; // 从1开始递增的ID
                for (let i = 0; i < a.data; i += this.interval) {
                  const end = Math.min(i + this.interval - 1, a.data - 1);
                  this.radioArr.push({ id, start: i + 1, end: end + 1 });
                  id++;
                }
                this.exportVisible = false;
                this.radio = "";
                this.exportChangeNumVisible = true;
              } else {
                topExportData = {
                  companyId: this.exportForm.qiye,
                  orderType: this.exportForm.orderType,
                  cardType: this.exportForm.type,
                  startTime: this.exportForm.startTime,
                  endTime: this.exportForm.endTime,
                  pageNum: this.exportForm.pageNum,
                  pageSize: this.exportForm.pageSize,
                  // regionId: this.exportForm.fenqu,
                  type: 1,
                  limitStart: 1,
                  limitEnd: a.data
                };
                if (this.exportKongFen == 1) {
                  // eslint-disable-next-line no-const-assign
                  topExportData.isKf = false;

                  //
                }
                if (this.exportKongFen == 2) {
                  // eslint-disable-next-line no-const-assign
                  topExportData.isKf = true;
                }
                handleConfirm("确认导出吗?", "info")
                  .then(() => {
                    this.$api.order.topExport(topExportData).then(res => {
                      handleAlert("导出成功", "success");
                      this.exportVisible = false;
                      const link = document.createElement("a");
                      link.style.display = "none";
                      link.href = URL.createObjectURL(res);
                      link.setAttribute("download", "充值订单.xls");
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    });
                  })
                  .catch(() => {
                    return;
                  });
              }
            }
          });
        } else {
          return false;
        }
      });
    },
    export() {
      this.exportVisible = true;
      this.exportForm = {
        qiye: [],
        fenqu: [],
        type: "",
        orderType: [],
        startTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 500000
      };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.exportForm.clearValidate();
      });
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    getZone() {
      this.$api.marketing.allZonePull().then(res => {
        if (res.code === 200) {
          this.zoneArr = res.data;
        }
      });
    },

    // 员工下拉接口
    getUser() {
      this.$api.zone.peoplePull().then(res => {
        if (res.code === 200) {
          this.caozuorenArr = res.data.list;
        }
      });
    },

    getStat() {
      this.$api.order
        .topOrderStatNew({
          orderNo: this.form.orderNo,
          userNum: this.form.userNum,
          payType: this.form.payType,
          waterCard: this.form.waterCard,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          orderType: this.form.orderType,
          regionId: this.form.fenqu,
          staffId: this.form.caozuo,
          isRefund: this.form.isRefund,
          cardType: this.form.cardType,
          isKf: this.form.isKf
        })
        .then(res => {
          if (res.code == 200) {
            this.rechargeReal = (
              Number(res.data.rechargeReal) + Number(res.data.rechargeGive)
            ).toFixed(2);
            this.rechargeReal = (
              Number(res.data.rechargeReal) + Number(res.data.rechargeGive)
            ).toFixed(2);
            this.outrechargeReal = (
              Number(res.data.outReal) + Number(res.data.outGive)
            ).toFixed(2);
            this.actual = (
              Number(res.data.consumeGive) + Number(res.data.consumeReal)
            ).toFixed(2);
            this.undetermined = (
              Number(this.rechargeReal) - Number(this.actual)
            ).toFixed(2);
            this.allSend = res.data.rechargeGive;
            this.allPay = res.data.rechargeReal;
            this.outallSend = res.data.outGive;
            this.outallPay = res.data.outReal;
            this.actualSend = res.data.consumeGive;
            this.actualPay = res.data.consumeReal;
            this.qianyiallSend = res.data.changeGive;
            this.qianyiallPay = res.data.changeReal;
            this.qianyirechargeNum = res.data.changeNum;
            this.qianyirechargeReal = (
              Number(res.data.changeGive) + Number(res.data.changeReal)
            ).toFixed(2);
            this.undeterminedSend =
              Number(res.data.rechargeGive) -
              Number(res.data.consumeGive).toFixed(2);

            this.undeterminedPay =
              Number(res.data.rechargeReal) -
              Number(res.data.consumeReal).toFixed(2);

            this.rechargeNum = res.data.rechargeNum;
            this.outrechargeNum = res.data.outNum;
            this.shiftMoney = (
              Number(res.data.shiftGive) + Number(res.data.shiftReal)
            ).toFixed(2);
            this.shiftGive = res.data.shiftGive;
            this.shiftReal = res.data.shiftReal;
          }
        });
    },
    reset() {
      this.form = { fenqu: [], startTime: "", endTime: "" };
      this.getList();
      this.getStat();
    },
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.order
        .topOrderList({
          pageNum: this.page,
          pageSize: this.pageSize,
          orderNo: this.form.orderNo,
          userNum: this.form.userNum,
          payType: this.form.payType,
          waterCard: this.form.waterCard,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          orderType: this.form.orderType,
          regionId: this.form.fenqu,
          staffId: this.form.caozuo,
          isRefund: this.form.isRefund,
          cardType: this.form.cardType,
          isKf: this.form.isKf
        })
        .then(res => {
          if (res.code === 200) {
            this.tableData = res.data.rows;
            this.total = res.data.total;
          }
        });
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    }
  }
};
</script>

<style lang="scss" scoped>
.moreBtn {
  cursor: pointer;
  color: #1684fc;
}
</style>
